<template>
  <div class="room-setting-quality-component p-5">
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("displayQuality.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("displayQuality.text") }}</p>
      </div>
      <div class="room-setting-input-box">
        <div class="room-set-block-btn-box">
          <ul>
            <li v-for="quality in qualityList"
                :key="quality.type"
                :class="{ selected : params.videoQuality == quality.type }"
                @click="selectedQuality = quality.type">
              <button class="room-set-block-btn" tabindex="1">{{ quality.name }}</button>
            </li>
          </ul>
        </div>
      </div>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text"><span v-text="qualityText"></span> </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
  },
  data(){
    return{
      qualityList: [
        {type : 'auto', name: this.$t('displayQuality.auto')},
        {type : 'hd', name: this.$t('displayQuality.normal')},
        {type : 'fhd', name: this.$t('displayQuality.high')},
      ],
      selectedQuality: "",
      qualityText: ""
    }
  },
  computed:{
    ...mapGetters('roomSetting', ['params'])
  },
  watch:{
    selectedQuality(){
      this.setQualityInfo()
    }
  },
  mounted(){
    this.selectedQuality = this.params.videoQuality
    this.setQualityInfo()
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
    setQualityInfo(){
      if(this.selectedQuality == 'auto'){
        this.qualityText = this.$t('setting.quality.explain.auto')
      } else if(this.selectedQuality == 'hd'){
        this.qualityText = this.$t('setting.quality.explain.hd')
      } else if(this.selectedQuality == 'fhd'){
        this.qualityText = this.$t('setting.quality.explain.fhd')
      }
      this.CHANGE_SETTING_DATA({ type:'videoQuality', value: this.selectedQuality})
    }
  }
}
</script>

<style lang='scss' scoped>

</style>